import { Instagram, MessageCircle } from "lucide-react";
import { BRAND } from "../../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#2C2520] text-mo-cream pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-[#F9F6F0]/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={BRAND.logo}
                alt="Maati Organics"
                className="h-14 w-14 object-contain rounded-full bg-mo-cream/10 p-1"
              />
              <div>
                <div className="font-serif-display text-2xl">Maati Organics</div>
                <div className="text-[11px] uppercase tracking-[0.22em] text-mo-cream/60">
                  From earth to plate
                </div>
              </div>
            </div>
            <p className="text-sm text-mo-cream/70 max-w-md leading-relaxed">
              Small-batch, hand-ground, organic spices born in the courtyards of
              Karnataka. Made with the kind of care your grandmother would nod at.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.22em] text-mo-cream/50 mb-5">
              Shop
            </div>
            <ul className="space-y-3 text-sm">
              <li><a href="#products" className="hover:text-mo-turmeric transition-colors">Haldi Powder</a></li>
              <li><a href="#products" className="hover:text-mo-turmeric transition-colors">Red Chilli Powder</a></li>
              <li><a href="#products" className="hover:text-mo-turmeric transition-colors">Masala Chilli Powder</a></li>
              <li><a href="#wholesale" className="hover:text-mo-turmeric transition-colors">Wholesale / B2B</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.22em] text-mo-cream/50 mb-5">
              Reach us
            </div>
            <div className="space-y-3 text-sm">
              <a
                href={BRAND.whatsapp.link}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 hover:text-mo-turmeric transition-colors"
                data-testid="footer-whatsapp"
              >
                <MessageCircle size={16} /> {BRAND.whatsapp.number}
              </a>
              <a
                href={BRAND.instagram.link}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-3 hover:text-mo-turmeric transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={16} /> {BRAND.instagram.handle}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-mo-cream/50">
          <div>© {new Date().getFullYear()} Maati Organics. All rights reserved.</div>
          <div className="font-serif-display italic">"If we can't eat it, we don't sell it."</div>
        </div>
      </div>
    </footer>
  );
};
